(function ($) {
  DJ.addBehavior('ideasTilesState', '.js-ideas-tiles-state', {
    attach: function () {
      const tilesWrapper = this;
      const items = tilesWrapper.querySelectorAll('.tile');
      const itemWithState = tilesWrapper.querySelector('.tile--with-state');
      const stateClass = 'tile--idea-state';
      const tileWithStateClass = 'tile--with-state';

      if (!items || !itemWithState) {
        return false;
      }

      /**
       * If at least one idea has state, add state class to ideas without state.
       * Needed to align titles on the same level visually.
       */
      Array.prototype.slice.call(items).forEach((item) => {
        if (!item.classList.contains(tileWithStateClass)) {
          item.classList.add(stateClass);
        }
      });

      return true;
    }
  });
})(jQuery);
